import PropTypes from 'prop-types'

import { useDesignVersionToggle } from '@/hooks'

import Dashboard from '../../Dashboard'

import SocialLinkToolbar from './SocialLinkToolbar'

const SocialLink = ({ children }) => {
  const { redirect, toggle } = useDesignVersionToggle({
    group: 'social-links',
    screen: 'SocialLinks',
    to: { path: '/dashboard/building-dashboard/social-links' },
    version: 'legacy',
  })

  if (redirect) return redirect

  return (
    <Dashboard.Container className="ctp-social-link">
      <SocialLinkToolbar onUIToggle={toggle} />
      <div className="ctp-social-link__inner">{children}</div>
    </Dashboard.Container>
  )
}

SocialLink.propTypes = {
  children: PropTypes.node,
}

export default SocialLink
